import React from 'react';
import { Navigate } from 'react-router-dom';

import StepInitial from '../features/Comprar/salud-flexible/step-initial';
import StepPlans from '../features/Comprar/salud-flexible/step-plans';
import StepData from '../features/Comprar/salud-flexible/step-data';
import StepDps from '../features/Comprar/salud-flexible/step-dps';
import StepAddress from '../features/Comprar/salud-flexible/step-address';
import StepPayment from '../features/Comprar/salud-flexible/step-payment';
import ThankYouPage from '../features/Comprar/salud-flexible/thankyou';
import ErrorServicePage from '../features/Comprar/salud-flexible/error-service';
import ErrorPage from '../features/Comprar/salud-flexible/error';
import { WrapperPageIntern } from '../components/organisms';
import { otherRoutes } from './otherRoutes';

const routes = (isLogged) => [
  {
    path: '/comprar/seguro-salud-flexible',
    element: <StepInitial />,
  },
  {
    path: '/comprar/seguro-salud-flexible/planes',
    element: isLogged ? <WrapperPageIntern component={<StepPlans />} /> : <Navigate to="/comprar/seguro-salud-flexible" replace />,
  },
  {
    path: '/comprar/seguro-salud-flexible/asegurados',
    element: isLogged ? <WrapperPageIntern component={<StepData />} /> : <Navigate to="/comprar/seguro-salud-flexible" replace />,
  },
  {
    path: '/comprar/seguro-salud-flexible/declaracion-salud',
    element: isLogged ? <WrapperPageIntern component={<StepDps />} /> : <Navigate to="/comprar/seguro-salud-flexible" replace />,
  },
  {
    path: '/comprar/seguro-salud-flexible/direccion',
    element: isLogged ? <WrapperPageIntern component={<StepAddress />} /> : <Navigate to="/comprar/seguro-salud-flexible" replace />,
  },
  {
    path: '/comprar/seguro-salud-flexible/pago',
    element: isLogged ? <WrapperPageIntern component={<StepPayment />} /> : <Navigate to="/comprar/seguro-salud-flexible" replace />,
  },
  {
    path: '/comprar/seguro-salud-flexible/gracias',
    element: isLogged ? <ThankYouPage /> : <Navigate to="/comprar/seguro-salud-flexible" replace />,
  },
  {
    path: '/comprar/seguro-salud-flexible/pago/error',
    element: isLogged ? <ErrorServicePage payment /> : <Navigate to="/comprar/seguro-salud-flexible" replace />,
  },
  {
    path: '/comprar/seguro-salud-flexible/error',
    element: isLogged ? <ErrorServicePage /> : <Navigate to="/comprar/seguro-salud-flexible" replace />,
  },
  {
    path: '/comprar/seguro-salud-flexible/page-error-:id',
    element: isLogged ? <ErrorServicePage /> : <Navigate to="/comprar/seguro-salud-flexible" replace />,
  },
  ...otherRoutes(isLogged),
  {
    path: '/comprar/seguro-salud-flexible/planes/gracias',
    element: isLogged ? <ErrorPage /> : <Navigate to="/comprar/seguro-salud-flexible" replace />,
  },
  {
    path: '/comprar/seguro-salud-flexible/planes/gracias-edad',
    element: isLogged ? <ErrorPage custom /> : <Navigate to="/comprar/seguro-salud-flexible" replace />,
  },
  {
    path: '/comprar/seguro-salud-flexible/planes/gracias-cliente',
    element: isLogged ? <ErrorPage /> : <Navigate to="/comprar/seguro-salud-flexible" replace />,
  },
  {
    path: '/comprar/seguro-salud-flexible/asegurados/gracias',
    element: isLogged ? <ErrorPage /> : <Navigate to="/comprar/seguro-salud-flexible" replace />,
  },
  {
    path: '/comprar/seguro-salud-flexible/declaracion-salud/gracias',
    element: isLogged ? <ErrorPage /> : <Navigate to="/comprar/seguro-salud-flexible" replace />,
  },
  {
    path: '*',
    element: <Navigate to="/comprar/seguro-salud-flexible" replace />,
  },
];

export default routes;
